








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AccessibilityButtonComponent extends Vue {

    @Prop({ default: 100 })
    private clickHoldDelay!: number;

    get clickHoldDelayValue(): number {
        return this.clickHoldDelay;
    }

    @Prop({ default: 'up' })
    public orientation!: 'up' | 'right' | 'down' | 'left';

    @Prop({ default: false })
    public extendedControls!: boolean;

    get clickHoldValues(): { fn: () => void, delay: number } {
        return {
            fn: () => this.$emit('click'),
            delay: this.clickHoldDelayValue
        };
    }

    get orientationValue(): string {
        return `mdi-arrow-${this.orientation}`;
    }

    @Prop({ default: 'medium' })
    public size!: 'medium' | 'large' | 'x-large';

    get sizeValue(): { [key: string]: boolean } {
        return { [this.size]: true };
    }
}
